// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-secondary-navigation>button{font-weight:600}@media (hover:hover){.c-secondary-navigation>button:hover span:last-child{--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));--tw-text-opacity:1;color:rgba(47,83,176,var(--tw-text-opacity))}}@media (min-width:48em){.c-secondary-navigation__nav{columns:2}}@media (min-width:64em){.c-secondary-navigation__nav{columns:3}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
